import React from 'react';
import { Box, Divider, Paragraph, StackView } from '@telus-uds/components-web';

import { ContentWrapper } from '../design/css';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Success = () => {
  const {
    contractSignature: { successPage: successEn }
  } = EN;
  const {
    contractSignature: { successPage: successFr }
  } = FR;

  return (
    <>
      <StackView space={4}>
        <Divider />
        <Divider />
      </StackView>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>{successEn}</Paragraph>
          <Box>
            <br />
          </Box>
          <Paragraph>{successFr}</Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
